/**
 * DOG OWNED — mobile navigation.
 *
 * The navigation is a <details> element, so it opens, closes and is keyboard
 * operable with no JavaScript at all. This file only adds the affordances that
 * <details> does not provide for a modal drawer:
 *
 *   - Escape closes the drawer and returns focus to the toggle
 *   - clicking the backdrop closes it
 *   - Tab is kept inside the panel while it is open
 *   - reaching the desktop breakpoint closes it
 *
 * Scroll locking is not handled here. critical.css already locks the page for
 * details[scroll-lock][open], which is why the markup carries that attribute.
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 990px)';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function setupMobileNav(nav) {
    var toggle = nav.querySelector('[data-mobile-nav-toggle]');
    var panel = nav.querySelector('[data-mobile-nav-panel]');

    if (!toggle || !panel) return;

    function close(returnFocus) {
      if (!nav.open) return;
      nav.open = false;
      if (returnFocus) toggle.focus();
    }

    // Move focus into the drawer when it opens so keyboard and screen reader
    // users land in the panel rather than behind the backdrop.
    nav.addEventListener('toggle', function () {
      if (!nav.open) return;
      var target = panel.querySelector('[data-mobile-nav-close]') || panel.querySelector(FOCUSABLE);
      if (target) target.focus();
    });

    nav.addEventListener('keydown', function (event) {
      if (!nav.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });

      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    nav.addEventListener('click', function (event) {
      // The backdrop is a ::after pseudo-element on the <details>, so a click
      // on it reports the <details> itself as the target.
      if (event.target === nav) {
        close(true);
        return;
      }

      if (event.target.closest('[data-mobile-nav-close]')) {
        event.preventDefault();
        close(true);
        return;
      }

      // Same-page links would otherwise leave the drawer open over the target.
      if (event.target.closest('[data-mobile-nav-panel] a')) {
        close(false);
      }
    });

    var desktop = window.matchMedia(DESKTOP_QUERY);
    var onBreakpointChange = function (event) {
      if (event.matches) close(false);
    };

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', onBreakpointChange);
    } else {
      desktop.addListener(onBreakpointChange);
    }
  }

  function init() {
    document.querySelectorAll('[data-mobile-nav]').forEach(setupMobileNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    var nav = event.target.querySelector('[data-mobile-nav]');
    if (nav) setupMobileNav(nav);
  });
})();
